"use client"

import { useIsMobile } from "@/hooks/use-is-mobile"
import { BlogGlassCard } from "@/components/blog/blog-glass-card"

interface Post {
  id: string
  title: string
  excerpt: string
  category: string
  date_published?: string
  image: string
  featured?: boolean
  slug: string
  reading_time?: number
}

interface ResponsiveBlogCardsProps {
  posts: Post[]
  className?: string
}

export function ResponsiveBlogCards({ posts, className }: ResponsiveBlogCardsProps) {
  const isMobile = useIsMobile()

  return (
    <ul
      className={`list-none p-0 m-0 ${isMobile ? 'space-y-5' : 'grid md:grid-cols-3 gap-8'} ${className || ''}`}
      aria-label="Related articles"
    >
      {posts.map((post) => (
        <li key={post.id} className="list-none h-full">
          <BlogGlassCard post={post} />
        </li>
      ))}
    </ul>
  )
}
